import React from 'react';

import DefaultGuides from "../../../src/images/entrypage/default_guides.svg";
import { prepareOptionsForLocationSearch } from "../../../src/js/helpers";
import TopMenu from "../../SharedComponents/TopMenu";
import Footer from "../../SharedComponents/Footer";

import './index.sass';


const GuidePage = ({ categories, footer, guide, regions, topMenu }) => {

  const { body, image, title } = guide;
  const regionsOptions = prepareOptionsForLocationSearch(regions);

  return (
    <div className="guide">

      <TopMenu
        {...topMenu}
        categories={categories}
        regionsOptions={regionsOptions}
        withSearch={true}
      />

      <div className="container">

        <div className="guide__headline">
          <h1>{ title }</h1>
          <img alt={guide.title}
               className={`guides__guide-image lazyload ${image && image.url ? '' : 'default'}`}
               data-src={(image && image.url) || DefaultGuides}
               data-expand="100"
               data-sizes="auto" />
          <div className="guide__background" />
        </div>

        <div className="guide__body" dangerouslySetInnerHTML={{ __html: body }} />
      </div>

      <Footer { ...footer } />
    </div>
  )
}

export default GuidePage;
